import { render } from "./Cabecalho.vue?vue&type=template&id=2d42efea"
import script from "./Cabecalho.vue?vue&type=script&lang=js"
export * from "./Cabecalho.vue?vue&type=script&lang=js"

import "./Cabecalho.vue?vue&type=style&index=0&id=2d42efea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__